import { useFormContext, useForm, FormProvider } from "react-hook-form";
import { Button } from "@moneyforward/mfx_biz_react_components";
import React, { useEffect, useState } from "react";
import {
  KanaNameFormField,
  NameFormField,
  TermsFormField,
} from "@/components/molecules";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { useIsSpMode } from "@/hooks";
import config from "@/libs/config";

type FormValues = {
  privacyPolicy: boolean;
  termOfUse: boolean;
  specialTerm: boolean;
  adEmailDelivery: boolean;
};

type Props = {
  onSubmit?: (v: any) => void;
};

export const BizsolRegisterCompanyFormFew = ({ onSubmit }: Props) => {
  const isSpMode = useIsSpMode();
  const { handleSubmit, formState } = useFormContext();

  const methods = useForm<FormValues>({
    reValidateMode: "onBlur",
  });

  const formValues = methods.getValues();

  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    setAgreed(
      formValues.privacyPolicy &&
        formValues.termOfUse &&
        formValues.specialTerm &&
        formValues.adEmailDelivery
    );
  }, [formValues]);

  return (
    <div css={container}>
      <form onSubmit={handleSubmit(onSubmit)} css={form}>
        <div css={!isSpMode ? box : spModeBox}>
          <div css={!isSpMode ? inputList : spModeInputList}>
            <div css={listItem}>
              <NameFormField
                nameLastName="lastName"
                nameFirstName="firstName"
              />
            </div>
            <div css={listItem}>
              <KanaNameFormField
                nameLastName="lastNameKana"
                nameFirstName="firstNameKana"
              />
            </div>
          </div>
        </div>
        <FormProvider {...methods}>
          <TermsFormField
            privacyPolicy="privacyPolicy"
            termOfUse="termOfUse"
            specialTerm="specialTerm"
            adEmailDelivery="adEmailDelivery"
            usingExternalIdp={config.USING_EXTERNAL_IDP}
          ></TermsFormField>
        </FormProvider>
        <div css={buttonWrapper}>
          <Button
            type="submit"
            variant="primary"
            disabled={formState.isSubmitting || !agreed}
          >
            登録
          </Button>
        </div>
      </form>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  padding: "18px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const spModeBox = css({
  width: "100%",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "640px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
  paddingTop: "8px",
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "15px",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginTop: "24px",
});
